import { inject, InjectionToken, Provider } from '@angular/core';
import { DocumentDetailSignalState } from '../types';
import { DOCUMENT_DETAIL_SIGNAL_STORE } from '../store';

export const DOCUMENTS_DETAIL_TOKEN =
  new InjectionToken<DocumentDetailSignalState>('Submitted Document Detail');

export const DOCUMENT_DETAIL_PROVIDER: Provider = {
  provide: DOCUMENTS_DETAIL_TOKEN,
  useClass: DOCUMENT_DETAIL_SIGNAL_STORE,
};

export function submittedDocDetailTokenizer() {
  return inject(DOCUMENTS_DETAIL_TOKEN);
}
